import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';

import { IconSetService } from '@coreui/icons-angular';
import { freeSet } from '@coreui/icons';
import { RequestService } from './service/api/request.service';
import { UtilService } from './service/Util/Util'
import { StorageService } from './service/storage/storage.service';

@Component({
  // tslint:disable-next-line
  selector: 'body',
  template: '<router-outlet></router-outlet>',
  providers: [IconSetService],
})
export class AppComponent implements OnInit {
  constructor(
    private router: Router,
    public iconSet: IconSetService,
    private requestService: RequestService, 
    private utilService : UtilService,
    private storageService : StorageService,
    private activatedRoute: ActivatedRoute,
  ) {
    // iconSet singleton
    iconSet.icons = { ...freeSet };
  }

  userToken = ''

  async ngOnInit() {
    console.log('app.component.ts check');
    this.router.events.subscribe((evt) => {
      if (!(evt instanceof NavigationEnd)) {
        return;
      }
      window.scrollTo(0, 0);
    });
    let token  = await this.storageService.getStorage('token')
    if(!token){
      await this.generateToken();
    }
    
  }

  async generateToken(){  
    
    let parentService = this.requestService.getParentAPI();
    parentService.handleExpired(0); 
  }
}
